import { FieldIds } from "./types";

/**
 * This function is specially created for penny drop tab to get the selected info from the graphQLResponse based on the selected item
 * @param selectedItem - The selected section
 * @param graphQLResponse - The graphQLResponse which is from backend
 * @returns The selected info which is used to populate the journey builder form
 */

export const getSelectedInfo = (selectedItem: any, graphQLResponse: any) => {
  const accountNumberField = selectedItem?.nestedfieldList?.find(
    (item: any) => item?.id === FieldIds.ACCOUNT_NUMBER
  );

  if (accountNumberField?.value && graphQLResponse?.bankDetails) {
    const bankDetails = graphQLResponse?.bankDetails?.find(
      (item: any) => item?.accountNumber === accountNumberField?.value
    );
    return bankDetails;
  }

  return null;
};

export function extractIdValueMap(referenceObject: any) {
  const result: any = {};
  if (
    typeof referenceObject === "object" &&
    Array.isArray(referenceObject?.nestedfieldList)
  ) {
    referenceObject.nestedfieldList.forEach((field: any) => {
      const value = field.value;
      // If value is an object, set it to empty string to avoid React rendering issues
      result[field.id] = typeof value === "object" ? "" : value;
    });
  }

  return result;
}
